var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonServiceApiTags } from 'common/services/api-tags';
import { useNotificationDrawerStore } from '../../service/notification-drawer-service/service-store/service-store';
import { Drawer } from 'ui-kit/drawer';
import { Tabs } from 'ui-kit/tabs';
import { Box } from 'ui-kit/box';
import { LoaderWrapperWithQueryKey } from 'common/components/loader-wrapper-with-query-key';
import { NotificationListContainer, NotificationListController, NotificationListActions } from './modules';
import { checkEqual } from 'common/helpers/checkEqual';
import styles from './notification-drawer.module.scss';
export var NotificationDrawer = function () {
    var t = useTranslation().t;
    var _a = useNotificationDrawerStore(function (state) { return ({ closeDrawer: state.closeDrawer, setOnlyNotRead: state.setOnlyNotRead, isOpen: state.isOpen }); }, checkEqual), closeDrawer = _a.closeDrawer, setOnlyNotRead = _a.setOnlyNotRead, isOpen = _a.isOpen;
    var notificationContainerRef = useRef(null);
    var tabs = [t('common.notificationDrawer.tabs.all'), t('common.notificationDrawer.tabs.notRead')];
    var onTabClick = useCallback(function (tabIndex) {
        setOnlyNotRead(!!tabIndex);
    }, [setOnlyNotRead]);
    return (_jsx(Drawer, __assign({ isClosedByOverlayClick: true, className: styles.drawer, side: "right", isOpen: isOpen, size: "small", title: t('common.notificationDrawer.title'), onClose: closeDrawer }, { children: _jsxs(LoaderWrapperWithQueryKey, __assign({ className: styles.contentWrapper, queryKeys: [CommonServiceApiTags.NotificationDrawer] }, { children: [_jsx(NotificationListActions, { pb: 12 }), _jsx(Box, __assign({ display: "block", px: 8 }, { children: _jsx(Tabs, { tabs: tabs, additionalTabClickHandler: onTabClick }) })), _jsx(NotificationListContainer, __assign({ ref: notificationContainerRef }, { children: _jsx(_Fragment, { children: _jsx(NotificationListController, { notificationContainerRef: notificationContainerRef }) }) }))] })) })));
};
